import {formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import BrandImage from 'components/receipt/commons/BrandImage'
import ItemTable from 'components/receipt/commons/ListItemBox/ItemTable'
import Subtotal from 'components/receipt/commons/CountingBox/Subtotal'
import Gratuity from 'components/receipt/commons/CountingBox/Gratuity'
import ReceiptTax from 'components/receipt/commons/CountingBox/ReceiptTax'
import Total from 'components/receipt/previews/Total'
import styles from './ReceiptPreview.css'
import {rupiah} from 'utils/formatter'
import Notes from 'components/receipt/commons/Notes'
import DiscountTable from 'components/receipt/commons/ListItemBox/DiscountTable'
import SocialMediaLink from 'components/receipt/commons/SocialMediaLink'
import InfoBox from 'components/receipt/previews/InfoBox'
import moment from 'moment'

class ReceiptPreview extends React.Component {
  render () {
    let {
      address = '',
      city = '',
      province = '',
      zipcode = '',
      phone = '',
      notes = ''
    } = this.props.form
    let {profile} = this.props.data.setting.receipt
    return (profile && <div className={`${styles.wrapper} receipt-preview-wrapper`}>
      <div className={styles.receipt}>
        <BrandImage
          businessLogo={profile.business.logo.url}
          businessName={profile.business.name}
          outletAddress={`${address}, ${city}, ${province}, ${zipcode}`}
          outletPhone={phone}
        />
        <InfoBox
          servedBy={this.DUMMY_INFO.servedBy}
          collectedBy={this.DUMMY_INFO.collectedBy}
          paymentNo={this.DUMMY_INFO.paymentNo}
          createdAt={this.DUMMY_INFO.createdAt}
        />
        <ItemTable checkouts={this.DUMMY_CHECKOUTS} checkoutPriceFormatter={rupiah} />
        <DiscountTable discounts={this.DUMMY_DISCOUNTS} />
        <div className={styles['counting-box']}>
          <Subtotal subtotal={110000} />
          <Gratuity includeGratuityTax={false} gratuities={this.DUMMY_GRATUITITES} />
          <ReceiptTax includeGratuityTax={false} taxes={this.DUMMY_TAXES} />
        </div>
        <Total cash={150000} change={40000} total={110000} />
        <SocialMediaLink
          instagram={profile.business.instagram}
          facebook={profile.business.facebook}
          twitter={profile.business.twitter}
          website={profile.business.website}
        />
        <Notes content={notes} />
        <div style={{clear: 'both'}} />
      </div>
    </div>)
  }

  DUMMY_CHECKOUTS = [
    {
      id: 1,
      item_name: 'Milk Tea',
      item_variant_name: 'Venti',
      price: 25000,
      quantity: 1,
      modifiers: [
        {
          modifier_name: 'Pearl',
          modifier_option_name: 'Sweet',
          price: 2000
        },
        {
          modifier_name: 'Grass Jelly',
          modifier_option_name: 'Salt',
          price: 2000
        },
        {
          modifier_name: 'Sugar',
          modifier_option_name: 'Rare',
          price: 2000
        }
      ],
      discounts: [
        {
          discount_name: 'Promo Sultan',
          discount_amount: 1000,
          discount_percentage: 0.5
        }
      ]
    },
    {
      id: 2,
      item_name: 'Nasi Goreng',
      item_variant_name: 'Ayam',
      price: 25000,
      quantity: 1,
      modifiers: [
        {
          modifier_name: 'Cabe',
          modifier_option_name: 'Sedikit',
          price: 1000
        }
      ],
      discounts: []
    },
    {
      id: 3,
      item_name: 'Beef Wellington',
      item_variant_name: '',
      price: 50000,
      quantity: 1,
      modifiers: [
        {
          modifier_name: 'Potato',
          modifier_option_name: 'Mashed',
          price: 10000
        },
        {
          modifier_name: 'Sauce',
          modifier_option_name: 'Mushroom',
          price: 4000
        }
      ],
      discounts: []
    }
  ];

  DUMMY_INFO = {
    createdAt: moment().format('Y-M-D H:m'),
    paymentNo: 'QGKTER5',
    servedBy: 'John Doe',
    collectedBy: 'Anne Doe'
  };

  DUMMY_DISCOUNTS = [
    {discount_name: 'Discount Test', discount_amount: -10000}
  ]

  DUMMY_TAXES = [
    {name: 'Tax Test', amount: 5, total: '10000'}
  ]

  DUMMY_GRATUITITES = [
    {name: 'Gratuity Test', amount: 5, total: '10000'}
  ]
}

ReceiptPreview.propTypes = {

}

let selector = formValueSelector('checkout') // must be same as ReceiptForm name reduxForm

function mapStateToProps (state) {
  return {
    form: {
      name: selector(state, 'name'),
      address: selector(state, 'address'),
      city: selector(state, 'city'),
      province: selector(state, 'province'),
      zipcode: selector(state, 'zipcode'),
      phone: selector(state, 'phone'),
      notes: selector(state, 'notes')
    },
    data: {
      outlet: state.outlet,
      setting: {
        receipt: state.setting.receipt
      }
    }
  }
}
export default connect(mapStateToProps)(ReceiptPreview)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Receipt/ReceiptPreview/ReceiptPreview.js